module.exports = __webpack_public_path__ + "img/image01.e030ccb0.jpg";